import "./NotificationMenu.css";

const timeAgo = (iso) => { try { const d=(Date.now()-new Date(iso).getTime())/3600000; return d<1?"just now":Math.floor(d)+"h ago"; } catch { return ""; } };

export default function NotificationMenu({ notifications=[], title="Notifications", emptyText="No notifications", onItemClick }) {
  return (
    <div className="gnb-menu-card nm-card">
      <p className="nm-title">{title}</p>
      <div className="nm-divider" />
      {notifications.length===0 ? <p className="nm-empty">{emptyText}</p> :
        <div className="nm-list">
          {notifications.map(n=>(
            <div
              key={n.id}
              className={"nm-item"+(onItemClick?" nm-item--clickable":"")}
              role={onItemClick?"button":undefined}
              tabIndex={onItemClick?0:undefined}
              onClick={onItemClick?()=>onItemClick(n):undefined}
              onKeyDown={onItemClick?(e)=>{ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); onItemClick(n); } }:undefined}
            >
              <div className="nm-row"><span className={"nm-ititle"+(n.isRead?"":" is-unread")}>{n.title}</span><span className="nm-time">{timeAgo(n.createdTime)}</span></div>
              <div className="nm-body">{n.body}</div>
            </div>
          ))}
        </div>}
    </div>
  );
}
